const fr = {
  // ── Nav ──────────────────────────────────────────────
  nav: {
    home:     'Accueil',
    services: 'Services',
    projects: 'Projets',
    about:    'À propos',
    contact:  'Contact',
    cta:      'Démarrer un projet',
  },

  // ── Hero ─────────────────────────────────────────────
  hero: {
    words: [
      { t: 'Développement', a: false },
      { t: 'web,',          a: false },
      { t: 'logiciel',      a: false },
      { t: 'et',            a: false },
      { t: 'IA',            a: true  },
      { t: 'sur',           a: false },
      { t: 'mesure.',       a: false },
    ],
    ariaLabel: 'Développement web, logiciel et IA sur mesure.',
    sub: 'Sites web, applications métier et solutions IA — conçus et livrés directement, sans intermédiaire.',
    ctaPrimary: 'Discuter de mon projet',
    ctaGhost:   'Voir mes services',
    stats: [
      ['10+', 'projets livrés'],
      ['24h', 'délai de réponse'],
      ['100%', 'sur mesure'],
    ],
    scroll: 'SCROLL',
  },

  // ── HomeAbout ─────────────────────────────────────────
  homeAbout: {
    eyebrow: 'À propos',
    title1:  'Un seul développeur,',
    title2:  'implication totale.',
    body:    'Je suis Islam B., développeur indépendant basé à Sherbrooke. Je conçois et livre des sites web, applications métier et solutions IA — seul, sans intermédiaire, du premier appel à la mise en ligne.',
    stack:   ['Sites web', 'Logiciel sur mesure', 'Solutions IA', 'Maintenance', 'UI/UX Design'],
    link:    'En savoir plus',
    stat1:   ['10+', 'projets livrés'],
    stat2:   ['100%', 'sur mesure'],
    stat3:   ['24 h', 'délai de réponse'],
    note:    '"Je m\'implique là où ça compte : comprendre ton métier avant de proposer une solution."',
  },

  // ── HomeServices ──────────────────────────────────────
  homeServices: {
    eyebrow: 'Ce que je fais',
    title:   'Des solutions adaptées\nà chaque besoin',
    cards: [
      { title: 'Sites web pour entreprises',         desc: 'Sites vitrines, landing pages, sites corporatifs, refonte et optimisation.' },
      { title: 'Développement logiciel sur mesure',  desc: 'Applications web, dashboards, portails clients, APIs, plateformes SaaS.' },
      { title: 'Solutions IA',                        desc: 'Agents IA, modèles prédictifs, systèmes multi-agents, vision par ordinateur.' },
      { title: 'Maintenance & évolution',             desc: 'Ajout de fonctionnalités, correction de bugs, migration, amélioration de performance.' },
    ],
  },

  // ── CTASection ────────────────────────────────────────
  cta: {
    tag:      '// PRÊT À DÉMARRER ?',
    title1:   'Vous avez un problème',
    title2:   'complexe à résoudre.',
    sub:      'Décrivez-le nous. On vous répond avec une approche claire, sans jargon, et sans engagement.',
    primary:  'Démarrer un projet',
    ghost:    'Découvrir nos services',
    chips:    ['✓ Réponse sous 24h', '✓ Sans engagement', '✓ Expertise directe'],
  },

  // ── Footer ────────────────────────────────────────────
  footer: {
    tagline:   'Studio indépendant · développement web,\nlogiciel & IA — Canada.',
    nav: ['Accueil', 'Services', 'Projets', 'À propos', 'Contact'],
    copy:      '© 2025 AxisDev — Islam B.',
    status:    'Disponible pour nouveaux projets',
  },

  // ── About (home section) ──────────────────────────────
  about: {
    eyebrow: 'À propos',
    title:   'AxisDev est un studio indépendant spécialisé en développement logiciel et intelligence artificielle.',
    body1:   'J\'accompagne les entreprises dans la création de sites web professionnels, d\'applications métier, d\'agents IA et de solutions logicielles sur mesure. Mon approche combine expertise technique, compréhension du besoin réel et développement de solutions concrètes, fiables et évolutives.',
    body2:   'Chaque projet est pris en charge directement — de l\'analyse initiale jusqu\'au déploiement — avec une communication claire et un accompagnement personnalisé.',
    cta1:    'Travailler ensemble',
    cta2:    'Ma méthode',
    tags:    ['Sites web & apps', 'Solutions IA / LLM', 'Design UI/UX', 'Cloud & DevOps', 'Sur mesure'],
    skills:  'Compétences clés',
  },

  // ── AboutPage ─────────────────────────────────────────
  aboutPage: {
    eyebrow:     'À propos',
    heroTitle:   'Développeur logiciel & spécialiste',
    heroAccent:  'en intelligence artificielle.',
    name:        'Islam B.',
    role:        'Fondateur · AxisDev',
    location:    'Basé au Canada · Disponible pour des projets à l\'international',
    skills:      ['Sites web', 'Applications métier', 'Solutions IA', 'Agents LLM', 'UI/UX Design', 'Cloud & DevOps', 'APIs', 'Automatisation'],
    cta1:        'Travailler ensemble',
    cta2:        'Ma méthode',
  },

  // ── Contact ───────────────────────────────────────────
  contact: {
    eyebrow:      'Contact',
    title:        'Vous avez un projet en tête\u00a0?',
    sub:          'Décrivez-le brièvement — je vous réponds dans les 24h.',
    nameLabel:    'Prénom et nom',
    emailLabel:   'Courriel',
    typeLabel:    'Type de projet',
    descLabel:    'Description du projet',
    projectTypes: ['Site web', 'Application logicielle', 'Solution IA', 'Maintenance', 'Autre'],
    typeDefault:  'Sélectionner...',
    namePh:       'exemple',
    emailPh:      'vous@exemple.com',
    descPh:       'Décrivez votre projet — objectifs, contraintes, délais souhaités...',
    submitBtn:    'Envoyer ma demande',
    successTitle: 'Demande envoyée',
    successSub:   'Je vous réponds dans les 24h.',
    emailLabel2:  'Email direct',
    callHint:     'Préférez-vous un appel\u00a0? Mentionnez-le dans votre message.',
  },

  // ── Projects ──────────────────────────────────────────
  projects: {
    eyebrow:    'Projets',
    title:      'Ce qu\'on a livré.',
    sub:        'Projets réels, en production. Chaque réalisation résout un problème métier concret.',
    visitSite:  'Visiter le site',
    teaserTag:  'Prochain projet',
    teaserText: 'Le vôtre pourrait être le suivant.\nParlons-en.',
    teaserCta:  'Démarrer le vôtre',
  },

  // ── Services Page ─────────────────────────────────────
  servicesPage: {
    eyebrow:    'Services',
    title1:     'Ce que je',
    title2:     'construis.',
    sub:        'Trois expertises, une seule adresse — directement à votre service, sans intermédiaire.',
    serviceCta: 'Voir ce service',
    services: [
      { title: 'Sites web pour entreprises',        desc: 'Sites vitrine, landing pages, sites corporatifs et refontes — modernes, crédibles et orientés conversion.',                                                                    pills: ['Site vitrine', 'Landing page', 'Refonte', 'SEO de base', 'Responsive'] },
      { title: 'Solutions IA sur mesure',            desc: 'Modèles prédictifs, agents IA, fine-tuning, vision par ordinateur et intégration dans vos logiciels existants.',                                                               pills: ['Agents IA', 'RAG', 'LLM fine-tuning', 'Vision', 'Multi-agents'] },
      { title: 'Développement logiciel',             desc: 'Applications web full-stack, SaaS, APIs et outils métier conçus pour tenir en production.',                                                                                     pills: ['Full-stack', 'SaaS', 'API REST', 'Mobile', 'Architecture'] },
      { title: 'Maintenance & évolution logicielle', desc: 'Reprise de projets existants, correction de bugs, ajout de fonctionnalités et migrations — sans repartir de zéro.',                                                             pills: ['Reprise de projet', 'Migration', 'Refonte UI', 'Performance', 'API'] },
    ],
  },
};

export default fr;
